// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NyN8","title":"styles_title__vNWZd"};